import e from "../../../utilities/tw.js";
const o = {
  base: e`w-full break-words rounded-lg bg-surface p-6 shadow-md`,
  imageContainer: e`aspect-h-9 aspect-w-16 mb-3 flex items-center justify-center`,
  image: e`size-full object-cover object-center`,
  chipsContainer: e`mb-3 flex space-x-2`,
  heading: e`mb-3 text-caption-lg font-bold`,
  descriptionText: e`mb-3 line-clamp-3 text-body-sm font-regular`,
  buttonContainer: e`flex justify-end`
};
export {
  o as cardStyles
};
